import { GetAsync } from "common/httpRequests";
import { BACKEND } from "constants/settings";

export async function GetVersionId() {
  const response = await GetAsync(
    `${BACKEND}/api/notificationservice/Notifications/supplier/refresh-state`,
  );
  return response?.data?.documentsRefreshId;
}

export async function GetNotifications() {
  const response = await GetAsync(
    `${BACKEND}/api/notificationservice/Notifications/supplier/portal`,
  );
  return response?.data;
}
